import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import API from '../../../redux/api';
import { commonToast } from "../../../Components/common";
import { CommonButton } from '../../../Components/common/commonButton';

const SwitchStatusDialog = ({ id, status, isOpen, setSwitchDialog, onSuccess }) => {
  // Local State
  const [isDisableConfirm, setIsDisableConfirm] = useState(false);

  const statusSwitch = status === 'Active' ? 'Inactive' : 'Active';
  
  const handleClose = () => {
    setSwitchDialog({ id: '', status: '', isOpen: false });
  };

  const handleConfirm = async () => {
    setIsDisableConfirm(true);
    const response = await API.patch(`users/users_api/user/${id}/`, {
      id: id,
      status: statusSwitch,
    });
    
    setIsDisableConfirm(false);
    handleClose();

    if (response.status === 200) {
      commonToast("success", 'User status updated successfully');
      if (typeof onSuccess === 'function') {
        try {
          onSuccess(id, statusSwitch);
        } catch (_) {
          // no-op
        }
      }
    } else {
      commonToast("error", 'Error updating user status');
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: "0 8px 32px rgba(22, 114, 222, 0.15)",
          overflow: "hidden",
        },
      }}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#ffffff",
          color: "#1672DE",
          padding: "20px 24px",
          fontWeight: "600",
          fontSize: "20px",
          margin: 0,
          borderBottom: "none",
        }}
      >
        Confirmation
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: "#ffffff",
          padding: "24px",
          paddingTop: "0px",
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            color: "#333",
            fontWeight: "400",
            lineHeight: "1.6",
          }}
        >
          Are you sure you want to {statusSwitch} this user?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: "#ffffff",
          padding: "16px 24px",
          borderTop: "1px solid #e0e0e0",
          gap: "12px",
          justifyContent: "flex-end",
        }}
      >
        <CommonButton
          text="Cancel"
          handleClick={handleClose}
          sx={{
            backgroundColor: "transparent",
            color: "#1672DE",
            border: "1px solid #1672DE",
            borderRadius: "10px",
            padding: "10px 24px",
            fontWeight: "600",
            fontSize: "14px",
            textTransform: "none",
            minHeight: "40px",
            minWidth: "120px",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              backgroundColor: "rgba(22, 114, 222, 0.05)",
              borderColor: "#1565c0",
              color: "#1565c0",
            },
          }}
        />
        <CommonButton
          text="Submit"
          handleClick={handleConfirm}
          disabled={isDisableConfirm}
          sx={{
            backgroundColor: "#1672DE",
            color: "white",
            borderRadius: "10px",
            padding: "10px 24px",
            fontWeight: "600",
            fontSize: "14px",
            textTransform: "none",
            minHeight: "40px",
            minWidth: "120px",
            boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#1565c0",
              boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
              transform: "translateY(-1px)",
            },
            "&:disabled": {
              backgroundColor: "#e0e0e0",
              color: "#9e9e9e",
              boxShadow: "none",
              transform: "none",
            },
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default SwitchStatusDialog;
